<template>
  <ModalDefault
    modal_id="addCategoriesModal"
    header="y"
    size="modal-md modal-dialog-scrollable"
    style_header=""
    :modal_header="'Adicionar categoria'"
    :footer="new_category.title"
    :method="alertAddCategory"
    icon="bx bx-badge-check mr-1"
  >
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="d-flex">
          <div
            class="file-upload-center cursor-default w-100"
            style="align-items: center; align-self: center"
          >
            <div class="d-block pt-2 px-2">
              <div class="col-12 px-0">
                <label class="mb-0">Nome da categoria </label>
                <div class="input-group mb-4">
                  <input
                    type="text"
                    v-model="new_category.title"
                    class="input-field"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
        <span
          @click.prevent="alertAddCategory"
          data-dismiss="modal"
          class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3"
        >
          <span class="">{{ getTranslations("expression_120") }}</span>
        </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import { mapGetters, mapState } from "vuex";
import $ from "jquery";

export default {
  name: "ModalAddCategory",
  components: {
    ModalDefault,
  },
  data() {
    return {
      new_category: {
        name: "",
      },
    };
  },
  mounted() {
    $("#addCategoriesModal").on("hidden.bs.modal", () => {
      this.new_category = {
        name: "",
      };
    });
  },
  computed: {
    ...mapState(["channels", "departments", "categories"]),
    ...mapGetters(["getDepartmentsArray"]),
  },
  methods: {
    alertAddCategory() {
      this.new_category.channel_id = this.channels.channel.id;
      this.new_category.department_id = this.channels.edit.department_id;
      this.$store.dispatch("addCategory", this.new_category);
      $("#addCategoriesModal").modal("hide");
    },
  },
};
</script>

<style scoped>
.input-field {
  width: 100%;
  height: 2.5rem;
  border: 1px solid rgb(156 163 175 / 0.55);

  outline: none;
  background-color: white;
  color: #858796;
  @apply px-2;
}

.input-field:focus {
  border: 1px solid #919191;
}
</style>
